<template>
<v-main>

 <v-layout  row wrap  pa-3>
   <v-flex x12>
     <v-flex xs10 offset-xs1>
          <v-text-field
            label="Buscar recepcionista"
            single-line
            solo
            weight=1px
          ></v-text-field>
     </v-flex>
    </v-flex>
</v-layout>
<v-layout  row wrap >
   <v-flex x12>
     <v-flex xs10 offset-xs1>
          lista de recepcionsitas
     </v-flex>
    </v-flex>
</v-layout>
 <v-layout style="height: 100px; position: relative" right bottom >
    <v-btn  id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click=""  :to="{path:'/cadastrarRecepcionista'}">
          <v-icon  dark>add</v-icon>
    </v-btn>

  </v-layout>

</v-main>

</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'listaRecepcionista',
  data () {
    return {
      usuario: {}
    }
  },
  components: {
    // HelloWorld
  },
  created () {
    console.log('created...')
  }
}
</script>

<style  scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
